import { useLayoutEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate, Outlet, useLocation } from "react-router";

import { StreamContextWrapper } from "@/context/stream-context-wrapper";
import { useMe } from "@/context/user-context";
import { useBreakpoints } from "@/hooks/use-breakpoints";
import { Fallback } from "@/pages/error-page";
import { routes } from "@/routes";

import { NavDesktop } from "./nav-desktop";
import { NavMobile } from "./nav-mobile";

export function Layout() {
  const breakpoints = useBreakpoints();
  const location = useLocation();
  const { user } = useMe();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  // Garde d'onboarding basée sur la base, pas sur la metadata Clerk : celle-ci est
  // partagée entre la prod et les previews alors que leurs bases sont forkées, donc
  // un `onboardingComplete: true` peut pointer un profil absent ici. Sans ligne de
  // profil, toutes les routes de l'app renvoient 404 (fiche club, liste joueurs,
  // abonnements) : on renvoie sur l'onboarding au lieu d'afficher des écrans vides.
  if (!user.hasProfile) {
    return <Navigate to={routes.onboarding} />;
  }

  // Plus de paywall global : un club sans abonnement entre dans l'app et voit la
  // liste joueurs anonymisée. Chaque écran réservé aux abonnés porte sa propre
  // garde (teaser ou PremiumUpsell), et l'API refuse les données membres.
  return (
    <StreamContextWrapper>
      {breakpoints === "xl"
        ? (
            <div className="flex min-h-screen bg-neutral-100">
              <NavDesktop />
              <main className="ml-64 min-w-0 flex-1">
                <ErrorBoundary
                  FallbackComponent={Fallback}
                  resetKeys={[location.pathname]}
                >
                  <Outlet />
                </ErrorBoundary>
              </main>
            </div>
          )
        : (
            <NavMobile>
              <ErrorBoundary
                FallbackComponent={Fallback}
                resetKeys={[location.pathname]}
              >
                <Outlet />
              </ErrorBoundary>
            </NavMobile>
          )}

    </StreamContextWrapper>
  );
}
